import * as Config from '../../../config';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ButtonIconV2 from './ButtonIconV2';
import IconAdd from '../content/list/svg/IconAdd';

function DelayButton({ label, onClick, classNameEnable, classNameDisable, style, delay = 5000 }) {
  const [isEnabled, setEnabled] = useState(true);
  const click = () => {
    if (isEnabled) {
      setEnabled(false);
      onClick();
      setTimeout(() => { setEnabled(true); }, delay);
    }
  }

  return <ButtonIconV2
    className={isEnabled ? classNameEnable : classNameDisable}
    style={style}
    icon={<IconAdd size={21} color={Config.BRAND_PRIMARY} />}
    label={label}
    onClick={click}
  />
}

DelayButton.propTypes = {
  label: PropTypes.string.isRequired,
  classNameEnable: PropTypes.string,
  classNameDisable: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object,
  delay: PropTypes.number,
}

export default DelayButton;
